var map = {
	"./crosshair.svg": "9a58",
	"./door-key.svg": "b92a",
	"./gloves.svg": "11a9",
	"./knife.svg": "5b28",
	"./machinegun.svg": "40f3",
	"./pistol.svg": "4d89",
	"./rifle.svg": "94cd",
	"./shotgun.svg": "db7a",
	"./smg.svg": "e025",
	"./sniperrifle.svg": "3735",
	"./splatter.svg": "5289",
	"./sticker.svg": "2b8f",
	"./tool-box.svg": "1c71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e9b";